export const focusTrapPosition = {
    start: 'start',
    end: 'end'
};
//# sourceMappingURL=focus-trap-position.js.map